import fr from './lang/fr';
import en from './lang/en';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import * as countries from 'i18n-iso-countries';
import countriesEn from 'i18n-iso-countries/langs/en.json';
import countriesFr from 'i18n-iso-countries/langs/fr.json';

countries.registerLocale(countriesEn);
countries.registerLocale(countriesFr);

Vue.use(VueI18n);
const translations = {
    'fr': fr,
    'en': en,
};
const locale = localStorage.getItem('tmz_public_lang') || 'fr';
export const vueI18nOptions = {
    locale: locale,
    messages: translations[locale],
    silentTranslationWarn: false,
};
export const i18n = new VueI18n(vueI18nOptions);
